import {ChoosePlansNavBarContainer, ChoosePlansNavBarUserInfo, ChoosePlansNavBarUserImage} from './ChoosePlansNavBar.styles';
import NavBarLogo from "components/images/NavBarLogo/NavBarLogo";
import {useAppSelector} from "store/hooks";
import {GreyTextBold, GreyTextLight} from "components/text/Text";
import { useNavigate } from "react-router-dom";


function ChoosePlansNavBar(){
  const navigate = useNavigate();
  const user = useAppSelector(state => state.user);

  return (
    <ChoosePlansNavBarContainer>
      <NavBarLogo onClick={() => navigate("/")}/>
      <ChoosePlansNavBarUserInfo>
        <ChoosePlansNavBarUserImage>
          <i className="fa-solid fa-user" style={{color: 'white', fontSize: '25px'}}/>
        </ChoosePlansNavBarUserImage>
        <GreyTextBold>{user.name}</GreyTextBold>
        <GreyTextLight>Donation Amount</GreyTextLight>
      </ChoosePlansNavBarUserInfo>
    </ChoosePlansNavBarContainer>
  )
}

export default ChoosePlansNavBar;
